const NimbusAcccordion = {
  /**
   * Initialize 
   */
  init: function() {
    this._keyDebounceRefresh = null;
    this._refreshRate = 300;
    this.bindEvents();
    this.mountAccordion();
  },
  /**
   * Reset Accordions
   */
  resetAccordions: function() {
    document.querySelectorAll('.abs-accordion-item').forEach(function(accordionItem) {
      let content = accordionItem.querySelector('.abs-accordion--content');      
      content.style.height = 'auto';
      content.classList.remove('abs-accordion--ready');
      accordionItem.classList.remove('abs-accordion--expanded');
      accordionItem.removeEventListener('click', this.itemEvent);
    });
  },
  /**
   * Mount Accordion
   */
  mountAccordion: function() {
    var self3 = this;
    document.querySelectorAll('.abs-accordion-item').forEach(function(accordionItem) {
      let content = accordionItem.querySelector('.abs-accordion--content');
      let contentStyles = window.getComputedStyle(content);
      content.style.height = contentStyles.height;
      content.classList.add('abs-accordion--ready');
      accordionItem.addEventListener('click', self3.itemEvent);
    });
  },
  /**
   * Apply event
   */
  itemEvent: function(event) {
    let _accordionItem = event.currentTarget;
      _accordionItem.classList.add('abs-accordion--skip-remove');
      _accordionItem.parentNode.parentNode.querySelectorAll('.abs-accordion--content').forEach(function(item) {
        if (!item.parentNode.classList.contains('abs-accordion--skip-remove')) {
          item.classList.remove('abs-accordion--expanded');
        }
      });
      _accordionItem.classList.remove('abs-accordion--skip-remove');
      _accordionItem.querySelector('.abs-accordion--content').classList.toggle('abs-accordion--expanded');
  },
  /**
   * Refresh Accordion
   */
  refresh: function() {
    clearTimeout(this._keyDebounceRefresh);
    var self1 = this;
    this._keyDebounceRefresh = setTimeout(function() {
      self1.resetAccordions();
      self1.mountAccordion();
      console.log('Debounce', 'NimbusAccordion Refreshed');
    }, self1._refreshRate);
  },
  /**
   * Bind Events
   */
  bindEvents: function() {
    var self2 = this;
    window.addEventListener('resize', function(event) {
      self2.refresh();
    });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  window.NimbusAcccordion = NimbusAcccordion;
  window.NimbusAcccordion.init();
});